import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';
import KIAImage from '../ui/image/KIAImage';
import LinkButton from '../ui/LinkButton';

interface InfoBoxImgTextLinksProps {
  title: string;
  image?: {
    src: string;
    alt: string;
    className?: string;
  };
  text: string;
  links: {
    text: string;
    url: string;
    openInNewTab?: boolean;
  }[];
  gap?: string;
  titleFontSize?: string;
  textFontSize?: string;
  headingPosition?: 'above' | 'below';
}

const InfoBoxImgTextLinks: React.FC<InfoBoxImgTextLinksProps> = ({
  title,
  image,
  text,
  links,
  gap = '16',
  titleFontSize = 'text-[30px] md:text-[40px] leading-[48px]',
  textFontSize = 'text-[12px] md:text-lg',
  headingPosition = 'above',
}) => {
  return (
    <m.section
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      className="flex flex-col items-center text-center mx-auto px-0 py-0"
    >
      {headingPosition === 'above' && (
        <m.h2
          variants={itemVariants}
          className={`${titleFontSize} font-medium mb-10`}
        >
          {title}
        </m.h2>
      )}

      {image && (
        <m.div variants={itemVariants}>
          <KIAImage {...image} className={`mb-6 ${image.className || ''}`} />
        </m.div>
      )}

      {headingPosition === 'below' && (
        <m.h2
          variants={itemVariants}
          className={`${titleFontSize} font-medium`}
        >
          {title}
        </m.h2>
      )}

      <m.p
        variants={itemVariants}
        className={`${textFontSize} p-4 mb-6 font-light`}
      >
        {text}
      </m.p>

      <m.div
        variants={itemVariants}
        className={`flex flex-wrap justify-center gap-8 md:gap-${gap}`}
      >
        {links.map((link, index) => (
          <m.div key={index} variants={itemVariants}>
            <LinkButton {...link} />
          </m.div>
        ))}
      </m.div>
    </m.section>
  );
};

export default InfoBoxImgTextLinks;
